module.exports = "<table id=\"tableHeader\" class=\"table table-condensed\">\n    <thead>\n        <tr role=\"rowheader\">\n            <th ng-repeat=\"item in $ctrl.items track by $index\" class=\"sorting\" st-ratio=\"{{item.ratio}}\">\n                {{item.label}}\n                <i ng-show=\"item.isSortable\" class=\"fa fa-sort\" aria-hidden=\"true\" ng-click=\"$ctrl.sort($index)\"></i>\n            </th>\n        </tr>\n    </thead>\n</table>";


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/components/table-component/table-header/table-header.html
// module id = 1378
// module chunks = 0